import { LOCATION_MSK, LOCATION_SPB } from 'app/const/location';

export const CATEGORY_MOST_INTRESTING = 'intresting';
export const CATEGORY_MOST_INTRESTING_TAG_ID = '2148';

export const CATEGORY_MAIN = '3';
export const CATEGORY_SOUPS = '2';
export const CATEGORY_SALADS = '1';
export const CATEGORY_BREAKFASTS = '6';
export const CATEGORY_DESSERT = '5';
export const CATEGORY_UPSELL = '7';
export const CATEGORY_SNACKS = '8'; // Запкуски
export const CATEGORY_FARM_PRODUCTS = '9';
export const CATEGORY_READY_TO_EAT = '99';

/*
    Категории, видимые только в определённых регионах (locationKey)
*/
export const CATEGORIES_VISIBLE_FOR_LOCATIONS = {
    [CATEGORY_READY_TO_EAT]: [LOCATION_MSK],
};

export const isCategoryVisibleForLocation = (categoryId, locationKey) => {
    const allowedLocations = CATEGORIES_VISIBLE_FOR_LOCATIONS[categoryId];
    if (!allowedLocations) return true;
    return allowedLocations.includes(locationKey);
};

/* для массива id категорий */
export const filterCategoriesByLocation = (categoryIds, locationKey) => categoryIds
    .filter((categoryId) => isCategoryVisibleForLocation(categoryId, locationKey));

/* для массива объектов категорий `{ id, ... }` (например, из period.categories) */
export const filterCategoryObjectsByLocation = (categories, locationKey) => categories
    .filter((category) => isCategoryVisibleForLocation(category.id, locationKey));


export const DEFAULT_CATEGORIES = [
    /* custom categories */
    CATEGORY_MOST_INTRESTING,
    /* regular categories */
    CATEGORY_MAIN,
    CATEGORY_SOUPS,
    CATEGORY_SALADS,
    CATEGORY_SNACKS,
    CATEGORY_BREAKFASTS,
    CATEGORY_DESSERT,
    CATEGORY_UPSELL,
    CATEGORY_READY_TO_EAT,
    CATEGORY_FARM_PRODUCTS,
];

export const CATEGORIES_URL_VALUES = {
    [CATEGORY_SALADS]: 'salads', // салаты
    [CATEGORY_SOUPS]: 'soups', // супы
    [CATEGORY_MAIN]: 'main_dishes', // основные блюда
    [CATEGORY_DESSERT]: 'snacks', // десерты
    [CATEGORY_SNACKS]: 'appetizer', // закуски
    [CATEGORY_BREAKFASTS]: 'breakfasts', // завтраки
    [CATEGORY_UPSELL]: 'fruit', // приятные мелочи
    [CATEGORY_MOST_INTRESTING]: 'intresting',
    [CATEGORY_FARM_PRODUCTS]: 'farm',
    [CATEGORY_READY_TO_EAT]: 'ready_to_eat',
};

export const CATEGORIES_URL_VALUES_IN_CIRILIKE = {
    [CATEGORY_SALADS]: 'Salads', // 'salads'
    [CATEGORY_SOUPS]: 'Soups', // 'soups,
    [CATEGORY_MAIN]: 'Main_dishes', // 'main_dishes',
    [CATEGORY_DESSERT]: 'Bakery', // 'snacks',
    [CATEGORY_SNACKS]: 'Snacks', // 'appetizer'
    [CATEGORY_BREAKFASTS]: 'Breakfast', // 'breakfasts',
    [CATEGORY_UPSELL]: 'приятные мелочи', // 'fruit',
    [CATEGORY_MOST_INTRESTING]: 'самое интересное',
    [CATEGORY_FARM_PRODUCTS]: 'фермерские продукты', // 'farm'
    [CATEGORY_READY_TO_EAT]: 'готовые блюда',
};

export const CATEGORIES_ICONS = {
    [CATEGORY_SALADS]: 'salads',
    [CATEGORY_SOUPS]: 'soups',
    [CATEGORY_MAIN]: 'main',
    [CATEGORY_DESSERT]: 'desserts',
    [CATEGORY_SNACKS]: 'snaks',
    [CATEGORY_BREAKFASTS]: 'breakfast',
    [CATEGORY_UPSELL]: 'upsell',
    [CATEGORY_FARM_PRODUCTS]: 'farm_products',
    [CATEGORY_READY_TO_EAT]: 'ready_to_eat',
};

/*
    Параметры используются для подбора меню по схеме и для управления раскрытыми категориями в корзине
*/
export const CATEGORIES_SCHEMA_IDS = {
    cl: 1,
    cs: 2,
    cm: 3,
    cn: 5,
    cb: 6,
    cf: 7,
    ca: 8,
    cr: 99,
};

export const CATEGORY_URL_PARAM_IDS = {
    salads: CATEGORY_SALADS,
    soups: CATEGORY_SOUPS,
    main_dishes: CATEGORY_MAIN,
    snacks: CATEGORY_DESSERT,
    breakfasts: CATEGORY_BREAKFASTS,
    fruit: CATEGORY_UPSELL,
    intresting: CATEGORY_MOST_INTRESTING,
    appetizer: CATEGORY_SNACKS,
    farm: CATEGORY_FARM_PRODUCTS,
    ready_to_eat: CATEGORY_READY_TO_EAT,
};

export const CATEGORIES_ORDER = [
    /* custom categories */
    CATEGORY_MOST_INTRESTING, // 0

    /* regular categories */
    CATEGORY_MAIN,
    CATEGORY_SOUPS,
    CATEGORY_SALADS,
    CATEGORY_SNACKS,
    CATEGORY_BREAKFASTS,
    CATEGORY_DESSERT,
    CATEGORY_READY_TO_EAT,
    CATEGORY_UPSELL,
    CATEGORY_FARM_PRODUCTS,
];

export const SUBCATEGORIES_ORDER = [
    'Смузи и коктейли',
    'Готовые десерты',
    'Cвежий прилавок',
    'Деликатесы',
    'Фирменные соусы',
    'Фермерские продукты',
];

export const SUBCATEGORIES_ANALYTICS_TITLES = {
    'Смузи и коктейли': 'Shop_drinks',
    'Готовые десерты': 'Shop_desserts',
    Десерты: 'Shop_desserts',
    'Свежий прилавок': 'Shop_dairy',
    Деликатесы: 'Shop_delicacy',
    'Фирменные соусы': 'Shop_sauses',
    'Фермерские продукты': 'Shop_farm',
};


export const CATEGORY_TITLES = {
    ru: {
        [CATEGORY_MAIN]: 'Основные блюда',
        [CATEGORY_SOUPS]: 'Супы',
        [CATEGORY_SALADS]: 'Салаты',
        [CATEGORY_SNACKS]: 'Закуски',
        [CATEGORY_BREAKFASTS]: 'Завтраки',
        [CATEGORY_DESSERT]: 'Выпечка и десерты',
        [CATEGORY_READY_TO_EAT]: 'Готовые блюда',
        [CATEGORY_UPSELL]: 'Приятные дополнения',
        [CATEGORY_MOST_INTRESTING]: 'Самое интересное',
        [CATEGORY_FARM_PRODUCTS]: 'Фермерские продукты',
        all: 'В корзине',
    },
    en: {
        [CATEGORY_MAIN]: 'Dinners',
        [CATEGORY_SOUPS]: 'Soups',
        [CATEGORY_SALADS]: 'Salads',
        [CATEGORY_SNACKS]: 'Snacks',
        [CATEGORY_BREAKFASTS]: 'Breakfasts',
        [CATEGORY_DESSERT]: 'Desserts',
        [CATEGORY_UPSELL]: 'Pleasant trifles',
        [CATEGORY_READY_TO_EAT]: 'Ready to eat',
        [CATEGORY_MOST_INTRESTING]: 'Our recommendation',
        [CATEGORY_FARM_PRODUCTS]: 'Farm products',
        all: 'Your order',
    },
};

export const CATEGORY_ANALYTICS_TITLES = {
    [CATEGORY_MAIN]: 'main_dishes',
    [CATEGORY_SOUPS]: 'soups',
    [CATEGORY_SALADS]: 'salads',
    [CATEGORY_SNACKS]: 'snacks',
    [CATEGORY_BREAKFASTS]: 'breakfasts',
    [CATEGORY_DESSERT]: 'desserts',
    [CATEGORY_UPSELL]: 'upsell',
    [CATEGORY_READY_TO_EAT]: 'ready_to_eat',
    [CATEGORY_MOST_INTRESTING]: 'most_interesting',
    [CATEGORY_FARM_PRODUCTS]: 'farm_products',
};


export const ADDITIONAL_DISHES_CATEGORIES = [CATEGORY_DESSERT, CATEGORY_UPSELL];

export const CATEGORIES_WITH_PORTION_ALIAS = [
    CATEGORY_MOST_INTRESTING,
    CATEGORY_MAIN,
    CATEGORY_SALADS,
    CATEGORY_DESSERT,
    CATEGORY_UPSELL,
    CATEGORY_FARM_PRODUCTS,
    CATEGORY_SNACKS,
];

export const CATEGORIES_WITH_CUSTOMIZATION = [
    CATEGORY_MAIN, CATEGORY_SOUPS,
];

// BR-1125
export const mostInterestingCategoryTitleForABTest = {
    ru: {
        intresting: 'Новое',
    },
    en: {
        intresting: 'Best',
    },
};

// BR1258
export const CATEGORIES_ORDER_MOBILE = [
    /* custom categories */
    CATEGORY_MOST_INTRESTING, // 0

    /* regular categories */
    CATEGORY_MAIN,
    CATEGORY_SOUPS,
    CATEGORY_SALADS,
    CATEGORY_SNACKS,
    CATEGORY_BREAKFASTS,
    CATEGORY_DESSERT,
    CATEGORY_READY_TO_EAT,
    CATEGORY_UPSELL,
];

export const CATEGORY_TITLES_MOBILE = {
    ru: {
        [CATEGORY_MAIN]: 'Основные блюда',
        [CATEGORY_SOUPS]: 'Супы',
        [CATEGORY_SALADS]: 'Салаты',
        [CATEGORY_SNACKS]: 'Закуски',
        [CATEGORY_BREAKFASTS]: 'Завтраки',
        [CATEGORY_DESSERT]: 'Выпечка и десерты',
        [CATEGORY_UPSELL]: 'Магазин',
        [CATEGORY_READY_TO_EAT]: 'Готовые блюда',
        [CATEGORY_MOST_INTRESTING]: 'Самое интересное',
        [CATEGORY_FARM_PRODUCTS]: 'Фермерские продукты',
        all: 'В корзине',
    },
    en: {
        [CATEGORY_MAIN]: 'Dinners',
        [CATEGORY_SOUPS]: 'Soups',
        [CATEGORY_SALADS]: 'Salads',
        [CATEGORY_SNACKS]: 'Snacks',
        [CATEGORY_BREAKFASTS]: 'Breakfasts',
        [CATEGORY_DESSERT]: 'Bakery',
        [CATEGORY_UPSELL]: 'Shop',
        [CATEGORY_READY_TO_EAT]: 'Ready to eat',
        [CATEGORY_MOST_INTRESTING]: 'Our recommendation',
        [CATEGORY_FARM_PRODUCTS]: 'Farm products',
        all: 'Your order',
    },
};
